export const FLAG_GETTING_BUS_WAIT_TIME_VIOLATIONS = 'FLAG_GETTING_BUS_WAIT_TIME_VIOLATIONS';
export const GET_BUS_WAIT_TIME_VIOLATIONS = 'GET_BUS_WAIT_TIME_VIOLATIONS';
export const CLEAR_BUS_WAIT_TIME_VIOLATIONS = 'CLEAR_BUS_WAIT_TIME_VIOLATIONS';